import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useAnimationFrame } from '@a-type/ui';
import { useMemo, useRef, useSyncExternalStore } from 'react';
function useMediaQuery(query) {
    const mediaQueryList = useMemo(() => window.matchMedia(query), [query]);
    return useSyncExternalStore((cb) => {
        mediaQueryList.addEventListener('change', cb);
        return () => mediaQueryList.removeEventListener('change', cb);
    }, () => mediaQueryList.matches);
}
export function ScrollTicker({ className, children, speed = 0.2, repeat = 50, ...props }) {
    const parentRef = useRef(null);
    const ref = useRef(null);
    const reverse = useRef(false);
    const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
    const normalizedChildren = typeof children === 'string' ? _jsx("div", { children: children }) : children;
    const xRef = useRef(0);
    useAnimationFrame(() => {
        if (prefersReducedMotion) {
            return;
        }
        if (ref.current && parentRef.current) {
            const marquee = parentRef.current;
            const scrollWidth = marquee.scrollWidth;
            const content = ref.current;
            const contentWidth = marquee.clientWidth;
            const x = xRef.current;
            if (x + contentWidth >= scrollWidth) {
                reverse.current = true;
            }
            if (x <= 0) {
                reverse.current = false;
            }
            const delta = speed * (reverse.current ? -1 : 1);
            xRef.current = x + delta;
            content.style.setProperty('--x', `${-xRef.current}px`);
        }
    }, [ref.current, prefersReducedMotion, speed]);
    return (_jsx(Box, { grow: true, overflow: "hidden", className: className, ref: parentRef, full: "width", ...props, children: _jsx(Box, { gap: "lg", full: "height", style: {
                whiteSpace: 'nowrap',
                transform: 'translateX(var(--x))',
                width: 'max-content',
            }, items: "center", ref: ref, children: new Array(repeat).fill(null).map((_, i) => (_jsx("div", { "aria-hidden": i > 0, children: normalizedChildren }, i))) }) }));
}
//# sourceMappingURL=ScrollTicker.js.map